import { first } from 'rxjs/operators';
import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[appFocus]',
})
export class FocusDirective implements OnInit {
  constructor(
    private elRef: ElementRef
  ) { }

  ngOnInit() {
    setTimeout(() => {
      // Verifica se o elemento possui um input
      // Se sim, foca no input
      const input = this.elRef.nativeElement.querySelector('input');
      if (input) {
        input.focus();
        return;
      }

      // Se não, foca no primeiro elemento filho
      let el = this.elRef.nativeElement;
      while (el.children.length > 0) {
        const elOld = el; // Guarda referência do elemento anterior
        el = el.children[0];

        // Caso o elemento capturado seja um Label e o elemento anterior tiver outro filho, tenta o segundo filho
        if (el.tagName === 'LABEL' && elOld.children.length > 1) {
          el = elOld.children[1];
        }
      }
      el.focus();
    }, 200);
  }
}
